import server from "./server";

export const getWorksApi = async () => {
  const response = await server().get("/works");
  return response.data;
};

export const getSingleWorkApi = async ({ slug }) => {
  const response = await server().get(`/works/slug/${slug}`);
  return response.data;
};

export const getSingleWorkByIdApi = async ({ id }) => {
  const response = await server().get(`/works/${id}`);
  return response.data;
};

export const createWorkApi = async ({ data }) => {
  const response = await server().post("/works", data);
  return response.data;
};

export const updateWorkApi = async ({ id, data }) => {
  const response = await server().put(`/works/${id}`, data);
  return response.data;
};

export const deleteWorkApi = async ({ id }) => {
  const response = await server().delete(`/works/${id}`);
  return response.data;
};
